import {useEffect, useState} from "react";
import Select from "react-select"
import styles from "../styles/ReactSelectStyles"
import dateUtils from "../utils/DateUtils";

const GenericInput = (props) => {

    const type = props.type
    const label = props.label;
    const [options, setOptions] = useState()
    const [value, setValue] = useState()
    const updateValue = props.updateValue

    useEffect(() => {
        setValue(props.value)
    }, [props.value]);

    useEffect(() => {
        setOptions(props.options)
    }, [props.options]);

    return (
        <>
            <div className="generic-input-container">
                <div className="input-label">{label}</div>
                <div className="input-container">
                    {type && type === "dropdown" ?
                        <Select name="traits.organisation_role" options={options}
                                getOptionLabel={option => option.name}
                                getOptionValue={option => option.id}
                                value={value}
                                placeholder=""
                                onChange={updateValue}
                                styles={styles.inputStyles}
                        />
                        : type && type === "number" ?
                            <input type="number" className="text-input-container" value={value}
                                   onChange={(ev) => {
                                       updateValue(ev.target.value)
                                   }}/>
                            : type && type === "date" ?
                                <input type="date" className="text-input-container" value={value}
                                       onChange={(ev) => {
                                           updateValue(ev.target.value)
                                       }}/>
                                : type && type === "select" ?
                                    <input type="checkbox"
                                           className={"text-input-container checkbox" + (props.disabled ? " disabled" : "")}
                                           checked={!!value}
                                           disabled={props.disabled}
                                           onChange={(ev) => {
                                               if (!props.disabled) updateValue(ev.target.checked)
                                           }}/>
                                :
                                <input type="text" className="text-input-container" value={value}
                                       onChange={(ev) => {
                                           updateValue(ev.target.value)
                                           }}/>
                    }

                </div>
            </div>
        </>
    )
}

export default GenericInput